var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isCategoriesPending)?_c('div',{staticClass:"loader"},[_c('b-spinner',{attrs:{"label":"Loading...","variant":"primary"}})],1):_vm._e(),_c('div',{ref:"patchContainer",attrs:{"id":_vm.patchId}})])}
var staticRenderFns = []

export { render, staticRenderFns }